import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
// Core modules imports are same as usual
import SwiperCore, { Navigation, 
// Pagination,
// Scrollbar,
A11y, Keyboard, 
//  Mousewheel,
Zoom, } from 'swiper';
// Direct React component imports
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
// Styles must use direct files imports
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/modules/navigation/navigation.scss'; // Navigation module
// import 'swiper/modules/pagination/pagination.scss'; // Pagination module
// import 'swiper/modules/scrollbar/scrollbar.scss';
import { Box } from "@mui/material";
import { useWidth } from "common-frontend-components"; // Pagination module
const modules = [
    // Navigation,
    // Pagination,
    // Scrollbar,
    A11y,
    Keyboard,
    //  Mousewheel,
    Zoom,
];
// configure Swiper to use modules
SwiperCore.use([Navigation, ...modules]);
export const GallerySwiper = ({ children, spaceBetween, slidesPerView, ...props }) => {
    return (_jsx(Box, { children: _jsx(Swiper
        // @ts-ignore
        // style={{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff'}}
        , { 
            // @ts-ignore
            // style={{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff'}}
            zoom: true, modules: modules, spaceBetween: spaceBetween, slidesPerView: slidesPerView, 
            //   navigation
            loop: true, autoHeight: true, 
            //   pagination={{ clickable: true, dynamicBullets: true }}
            keyboard: { "enabled": true }, ...props, children: Children.map(children, (i, index) => _jsx(SwiperSlide, { children: i }, index)) }, void 0) }, void 0));
};
export const GallerySwiperWithNavigation = ({ modules = [], ...props }) => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
         .swiper-button-next {
          color: transparent;
          margin-left: 8px;
          margin-right: 8px;
          transition: all .2s;
        }
        .swiper-button-next:hover {
          font-weight: 700;
          transform: scale(1.25);
          color: #fff;
        }
        .swiper-button-prev {
          color: transparent;
          margin-left: 8px;
          margin-right: 8px;
          transition: all .2s;
        }
        .swiper-button-prev:hover {
          font-weight: 700;
          transform: scale(1.25);
          color: #fff;
        }
        ` }, void 0), _jsx(GallerySwiper, { navigation: useWidth() > 500, modules: [
                    Navigation,
                    A11y,
                    Keyboard,
                    Zoom,
                ], ...props }, void 0)] }, void 0));
};
//# sourceMappingURL=GallerySwiper.js.map